<template>
    <b-card no-body>
        <b-card-header>
            <span class="h5">
                CONTRATO -
                <strong>
                    {{ contrato.vcCodigoEstruturado }} -
                    {{ contrato.fornecedor ? contrato.fornecedor.nome : '' }}
                </strong>
                <b-badge variant="warning" class="ml-2">{{ operacao }}</b-badge>
            </span>
        </b-card-header>
        <b-card-body>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row v-if="contratoElaboracao() || aditivarContrato()">
                <b-col sm="12" md="2">
                    <b-form-group>
                        <label class="required" for="numeroContrato">Número do contrato</label>
                        <b-input-group>
                            <b-form-input
                                type="text"
                                id="numeroContrato"
                                placeholder="Digite o número do contrato"
                                v-model="codigoEstruturado"
                                :state="
                                    $v.codigoEstruturado.$error ? false : null
                                "
                                @input.native="$v.codigoEstruturado.$touch()"
                                v-mask="'##.####'"
                                max="11"
                                :disabled="aditivarContrato()"
                            ></b-form-input>
                            <b-form-invalid-feedback
                                >O número do contrato é
                                obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="2">
                    <b-form-group>
                        <label for="numeroProcessoCliente">Processo cliente</label>
                        <b-input-group>
                            <b-form-input
                                type="text"
                                id="numeroProcessoCliente"
                                placeholder="Digite o número do processo do cliente"
                                v-model="processoCliente"
                            ></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label class="required">Gestor</label>
                        <b-form-select
                            :options="fornecedoresGestor"
                            v-model="codSolicitante"
                            text-field="nome"
                            value-field="codigo"
                            @input="$v.codSolicitante.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label class="required">Centro de Custo</label>
                        <b-form-select
                            :options="unidades"
                            v-model="codUnidade"
                            text-field="nomeCodCCusto"
                            value-field="codCCusto"
                            @input="$v.codUnidade.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2">
                    <b-form-group>
                        <label>Tipo do Contrato</label>
                        <b-form-select
                            :options="tipoContratoOptions"
                            v-model="tipoContratoId"
                            text-field="descricao"
                            value-field="tipoContratoId"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2">
                    <b-form-group>
                        <label>Garantia</label>
                        <b-form-select
                            :options="garantiaOptions"
                            v-model="flGarantiaContratual"
                            text-field="descrGarantia"
                            value-field="flGarantia"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2">
                    <b-form-group>
                        <label>Tipo do Setor</label>
                        <b-form-select
                            :options="tipoSetorOptions"
                            v-model="tipoSetor"
                            text-field="descricao"
                            value-field="codigo"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2">
                    <b-form-group>
                        <label>Tipo de Relação</label>
                        <b-form-select
                            :options="tipoRelacaoOptions"
                            v-model="tipoRelacao"
                            text-field="descricao"
                            value-field="codigo"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2" v-if="flGarantiaContratual === 1">
                    <b-form-group
                        :state="$v.percGarantia.$error ? false : null"
                        invalid-feedback="O percentual da garantia é obrigatório"
                    >
                        <label class="required">Valor %</label>
                        <money
                            v-model="percGarantia"
                            v-bind="money"
                            class="form-control text-right"
                        ></money>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2" v-if="false">
                    <b-form-group>
                        <label>Tipo do Movimento</label>
                        <b-form-select
                            :options="tipoMovimentoOptions"
                            v-model="tipoMovimento"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="2">
                    <b-form-group>
                        <b-checkbox 
                            class="mt-2 mb-2 pt-2"
                            v-model="renovacao" 
                        >
                            Renovação
                        </b-checkbox>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2" v-if="renovacao">
                    <b-form-group>
                        <label for="tipoContratacao"
                            >Índice do Reajuste</label
                        >
                        <b-form-select
                            class="mb-2 mr-sm-2 mb-sm-0"
                            :plain="true"
                            value-field="indice"
                            text-field="indice"
                            :options="indicesReajuste"
                            v-model="indiceReajuste"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2" v-if="renovacao">
                    <b-form-group>
                        <label>Valor do Reajuste</label>
                        <money 
                            v-model="valorReajuste"
                            v-bind="money"
                            class="form-control text-right mb-2 mr-sm-2 mb-sm-0"
                        ></money>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label class="required">Nome do Contrato</label>
                        <b-form-textarea
                            v-model="objetoContrato"
                            :rows="4"
                        ></b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="3">
                    <b-form-group
                        :state="$v.vigenciaInicio.$error ? false : null"
                        invalid-feedback="Data do início da vigência é obrigatória"
                    >
                        <label class="required">Vigência Início</label>
                        <date-picker
                            v-model="vigenciaInicio"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            @input.native="$v.vigenciaInicio.$touch()"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group
                        :state="$v.vigenciaFim.$error ? false : null"
                        invalid-feedback="Data do fim da vigência é obrigatória"
                    >
                        <label class="required">Vigência Fim</label>
                        <date-picker
                            v-model="vigenciaFim"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            @input.native="$v.vigenciaFim.$touch()"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group
                        :state="$v.prazoInicio.$error ? false : null"
                        invalid-feedback="Data do início do prazo é obrigatória"
                    >
                        <label class="required">Prazo Execução Início</label>
                        <date-picker
                            v-model="prazoInicio"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            @input.native="$v.prazoInicio.$touch()"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group
                        :state="$v.prazoFim.$error ? false : null"
                        invalid-feedback="Data do fim do prazo é obrigatória"
                    >
                        <label class="required">Prazo Execução Fim</label>
                        <date-picker
                            v-model="prazoFim"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            @input.native="$v.prazoFim.$touch()"
                        ></date-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <!-- <b-row>
                <b-col sm="12" md="3">
                    <b-form-group
                        :state="$v.dtEnvioFornecedor.$error ? false : null"
                        invalid-feedback="Data do envio ao fornecedor é obrigatória"
                    >
                        <label>Envio ao Fornecedor</label>
                        <date-picker
                            v-model="dtEnvioFornecedor"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            @input.native="$v.dtEnvioFornecedor.$touch()"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group
                        :state="$v.dtRetornoFornecedor.$error ? false : null"
                        invalid-feedback="Data de retorno do fornecedor é obrigatória"
                    >
                        <label>Retorno do Fornecedor</label>
                        <date-picker
                            v-model="dtRetornoFornecedor"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            @input.native="$v.dtRetornoFornecedor.$touch()"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group
                        :state="$v.dtEnvioDiretoria.$error ? false : null"
                        invalid-feedback="Data de envio a diretoria é obrigatória"
                    >
                        <label>Envio para Diretoria</label>
                        <date-picker
                            v-model="dtEnvioDiretoria"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            @input.native="$v.dtEnvioDiretoria.$touch()"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group
                        :state="$v.dtRetornoDiretoria.$error ? false : null"
                        invalid-feedback="Data de retorno da diretoria é obrigatória"
                    >
                        <label>Retorno da Diretoria</label>
                        <date-picker
                            v-model="dtRetornoDiretoria"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            @input.native="$v.dtRetornoDiretoria.$touch()"
                        ></date-picker>
                    </b-form-group>
                </b-col>
            </b-row> -->
            <b-row v-if="apostilamento() || atualizacaoContrato()">
                <b-col sm="12">
                    <b-form-group>
                        <label class="required">Justificativa {{ labelJustificativa }}</label>
                        <b-form-textarea
                            v-model="justificativaApostilamento"
                            :rows="2"
                            @input.native="
                                $v.justificativaApostilamento.$touch()
                            "
                            :state="
                                $v.justificativaApostilamento.$error
                                    ? false
                                    : null
                            "
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa {{ textoInfoJustificativa }} é obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
        </b-card-body>
        <b-card-footer>
            <b-button variant="danger" @click.stop="voltar()" class="mr-1">
                <span> <i class="fa fa-history"></i> Cancelar </span>
            </b-button>
            <b-button
                variant="primary"
                :disabled="desabilitarBtnSalvar"
                @click.stop="confirmaSalvar()"
            >
                <i class="fa fa-save"></i> Salvar
            </b-button>
        </b-card-footer>
    </b-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import ContratosServicos from './ContratosServicos'
import { situacaoContrato } from './SituacaoContrato'

export default {
    data() {
        return {
            contrato: {},
            erros: [],
            codigoEstruturado: '',
            processoCliente: '',
            operacao: '',
            codSolicitante: null,
            funcionarios: [],
            fornecedoresGestor: [],
            codUnidade: null,
            unidades: [],
            vigenciaInicio: null,
            vigenciaFim: null,
            prazoInicio: null,
            prazoFim: null,
            dtEnvioFornecedor: null,
            dtRetornoFornecedor: null,
            dtEnvioDiretoria: null,
            dtRetornoDiretoria: null,
            flGarantiaContratual: 0,
            tipoSetor: 0,
            tiposSetor: [],
            tipoSetorOptions: [],
            tipoRelacao: 0,
            tiposRelacao: [],
            tipoRelacaoOptions: [],
            percGarantia: 0,
            objetoContrato: '',
            garantiaOptions: [
                { flGarantia: 0, descrGarantia: 'NÃO' },
                { flGarantia: 1, descrGarantia: 'SIM' }
            ],
            tipoMovimentoOptions: ['1.1.80', '1.1.15', '1.1.79'],
            tipoContratoOptions: [],
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            },
            tipoContratoId: 0,
            tipoMovimento: '1.1.80',
            justificativaApostilamento: '',
            apostilar: null,
            labelJustificativa: '',
            textoInfoJustificativa: '',
            renovacao: false,       
            indiceReajuste: null,
            indicesReajuste: [],
            valorReajuste: 0
        }
    },

    methods: {
        voltar() {
            this.erros = []
            if (
                this.vigenciaInicio !=
                    this.$moment(this.contrato.dtInicioVigencia).format(
                        'DD/MM/YYYY'
                    ) ||
                this.vigenciaFim !=
                    this.$moment(this.contrato.dtFimVigencia).format(
                        'DD/MM/YYYY'
                    ) ||
                this.objetoContrato != this.contrato.vcObjetoContrato
            ) {
                this.$store.dispatch('setRecarregar', true)
            }
            this.$router.push({
                name: 'Contratos_Detalhar',
                params: {
                    contratoId: this.$route.params.contratoId
                }
            })
        },

        confirmaSalvar() {
            let acao = ''
            let titulo = ''
            if ((this.contratoElaboracao() || this.atualizacaoContrato()) && !this.$route.params.apostilar) {
                acao = 'a atualização'
                titulo = 'Atualização'
            } else if (this.apostilamento()) {
                acao = 'o apostilamento'
                titulo = 'Apostilamento'
            }

            this.$swal({
                title: titulo,
                html: `Confirma ${acao} para o contrato <b>${this.contrato.vcCodigoEstruturado} - ${this.contrato.fornecedor.nome}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            this.$store.dispatch('addRequest')
            let apostilamentoAtualizacaoDto = {
                idContrato: this.contrato.idContrato,
                codSolicitante: this.codSolicitante,
                codUnidade: this.codUnidade,
                nomeUnidade: this.unidades.find(x => x.codCCusto === this.codUnidade).nomeCCusto,
                dtInicioVigencia: this.$moment(
                    this.vigenciaInicio,
                    'DD/MM/YYYY'
                ),
                dtFimVigencia: this.$moment(this.vigenciaFim, 'DD/MM/YYYY'),
                dtInicioPrazoExecucao: this.$moment(
                    this.prazoInicio,
                    'DD/MM/YYYY'
                ),
                dtFimPrazoExecucao: this.$moment(this.prazoFim, 'DD/MM/YYYY'),
                // dtEnvioFornecedor: this.dtEnvioFornecedor != null ?  this.$moment(
                //     this.dtEnvioFornecedor,
                //     'DD/MM/YYYY'
                // ) : null,
                // dtRetornoFornecedor: this.dtRetornoFornecedor != null ? this.$moment(
                //     this.dtRetornoFornecedor,
                //     'DD/MM/YYYY'
                // ) : null,
                // dtEnvioDiretoria: this.dtEnvioDiretoria != null ? this.$moment(
                //     this.dtEnvioDiretoria,
                //     'DD/MM/YYYY'
                // ) : null,
                // dtRetornoDiretoria: this.dtRetornoDiretoria != null ? this.$moment(
                //     this.dtRetornoDiretoria,
                //     'DD/MM/YYYY'
                // ) : null,
                flGarantiaContratual: this.flGarantiaContratual,
                nuPercentGarantia: this.percGarantia,
                vcObjetoContrato: this.objetoContrato,
                processoCliente: this.processoCliente,
                tipoContratoId: this.tipoContratoId,
                tipoSetor: this.tipoSetor,
                tipoRelacao: this.tipoRelacao,
                tipoMovimento: this.tipoMovimento,
                isApostilamento: this.apostilar,
                renovacao: this.renovacao,
                indiceReajuste: this.renovacao ? this.indiceReajuste : null,
                valorReajuste: this.renovacao ? this.valorReajuste : null
            }
            if (this.contratoElaboracao() || this.aditivarContrato()) {
                apostilamentoAtualizacaoDto.justificativaApostilamento = null
                apostilamentoAtualizacaoDto.vcCodigoEstruturado = this.codigoEstruturado
                apostilamentoAtualizacaoDto.isAditivo = this.aditivarContrato()
                ContratosServicos.atualizarContrato(
                    apostilamentoAtualizacaoDto
                ).then(response => {
                    if (response) {
                        if (response.success) {
                            this.mensagemSucesso(response.data)
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            } else if (this.apostilamento()) {
                apostilamentoAtualizacaoDto.justificativaApostilamento = this.justificativaApostilamento
                ContratosServicos.apostilarContrato(
                    apostilamentoAtualizacaoDto
                ).then(response => {
                    if (response) {
                        if (response.success) {
                            this.mensagemSucesso(response.data)
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        },

        obterContrato() {
            this.$store.dispatch('addRequest')
            ContratosServicos.obterPorIdApostilar(
                this.$route.params.contratoId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.preencheFormulario(response.data)
                        this.verificaOperacao()
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        preencheFormulario(data) {
            this.contrato = data
            this.codigoEstruturado = data.vcCodigoEstruturado
            this.processoCliente = data.processoCliente
            this.unidades = data.unidades
            this.funcionarios = data.funcionarios
            this.fornecedoresGestor = data.fornecedoresGestor
            this.codSolicitante = data.codSolicitante
            this.codUnidade = data.codUnidade
            this.indicesReajuste = data.indicesReajuste
            this.indiceReajuste = data.indiceReajuste
            this.renovacao = data.renovacao
            this.valorReajuste = data.valorReajuste
            if (
                data.dtInicioVigencia != undefined &&
                data.dtFimVigencia != undefined &&
                data.dtInicioPrazoExecucao != undefined &&
                data.dtFimPrazoExecucao != undefined
                // data.dtEnvioFornecedor != undefined &&
                // data.dtRetornoFornecedor != undefined &&
                // data.dtEnvioDiretoria != undefined &&
                // data.dtRetornoDiretoria != undefined
            ) {
                this.vigenciaInicio = this.$moment(
                    data.dtInicioVigencia
                ).format('DD/MM/YYYY')
                this.vigenciaFim = this.$moment(data.dtFimVigencia).format(
                    'DD/MM/YYYY'
                )
                this.prazoInicio = this.$moment(
                    data.dtInicioPrazoExecucao
                ).format('DD/MM/YYYY')
                this.prazoFim = this.$moment(data.dtFimPrazoExecucao).format(
                    'DD/MM/YYYY'
                )
                // this.dtEnvioFornecedor = this.$moment(
                //     data.dtEnvioFornecedor
                // ).format('DD/MM/YYYY')
                // this.dtRetornoFornecedor = this.$moment(
                //     data.dtRetornoFornecedor
                // ).format('DD/MM/YYYY')
                // this.dtEnvioDiretoria = this.$moment(
                //     data.dtEnvioDiretoria
                // ).format('DD/MM/YYYY')
                // this.dtRetornoDiretoria = this.$moment(
                //     data.dtRetornoDiretoria
                // ).format('DD/MM/YYYY')
            }
            this.flGarantiaContratual = data.flGarantiaContratual
            this.percGarantia = data.nuPercentGarantia
                ? data.nuPercentGarantia
                : 0
            this.objetoContrato = data.vcObjetoContrato
            this.tipoContratoId = data.idTipoContrato
            this.tipoMovimento = data.tipoMovimento
                ? data.tipoMovimento
                : '1.1.80'
            this.definirTipoContratoOptions(data)
            this.tipoSetor = data.tipoSetor
            this.tipoSetorOptions = data.tiposSetor
            this.tipoRelacao = data.tipoRelacao
            this.tipoRelacaoOptions = data.tiposRelacao

        },
        
        definirTipoContratoOptions(contrato) {
            if (
                contrato.temFaseDemanda &&
                !contrato.temFaseEntrega &&
                !contrato.temFaseParcelaFixa
            ) {
                this.tipoContratoOptions.push({
                    tipoContratoId: 1,
                    descricao: 'POR DEMANDA'
                })
                this.tipoContratoOptions.push({
                    tipoContratoId: 4,
                    descricao: 'MISTO'
                })
            } else if (
                !contrato.temFaseDemanda &&
                contrato.temFaseEntrega &&
                !contrato.temFaseParcelaFixa
            ) {
                this.tipoContratoOptions.push({
                    tipoContratoId: 3,
                    descricao: 'POR ENTREGA'
                })
                this.tipoContratoOptions.push({
                    tipoContratoId: 4,
                    descricao: 'MISTO'
                })
            } else if (
                !contrato.temFaseDemanda &&
                !contrato.temFaseEntrega &&
                contrato.temFaseParcelaFixa
            ) {
                this.tipoContratoOptions.push({
                    tipoContratoId: 2,
                    descricao: 'PARCELA FIXA'
                })
                this.tipoContratoOptions.push({
                    tipoContratoId: 4,
                    descricao: 'MISTO'
                })
            } else if (
                (contrato.temFaseDemanda && contrato.temFaseEntrega) ||
                (contrato.temFaseDemanda && contrato.temFaseParcelaFixa) ||
                (contrato.temFaseEntrega && contrato.temFaseParcelaFixa) ||
                (contrato.temFaseDemanda &&
                    contrato.temFaseEntrega &&
                    contrato.temFaseParcelaFixa)
            ) {
                this.tipoContratoOptions.push({
                    tipoContratoId: 4,
                    descricao: 'MISTO'
                })
            } else {
                this.tipoContratoOptions.push({
                    tipoContratoId: 1,
                    descricao: 'POR DEMANDA'
                })
                this.tipoContratoOptions.push({
                    tipoContratoId: 2,
                    descricao: 'PARCELA FIXA'
                })
                this.tipoContratoOptions.push({
                    tipoContratoId: 3,
                    descricao: 'POR ENTREGA'
                })
                this.tipoContratoOptions.push({
                    tipoContratoId: 4,
                    descricao: 'MISTO'
                })
            }
        },

        mensagemSucesso() {
            let acao = ''
            if ((this.contratoElaboracao() || this.atualizacaoContrato()) && !this.apostilar) {
                acao = 'atualizado'
            } else if (this.apostilamento()) {
                acao = 'salvo'
            }

            this.$toast.success(
                `Registro ${acao} com sucesso!`,
                'OK',
                this.$toastConfig.success
            )
            this.voltar()
        },

        registrosInalterados() {
            return (
                this.codigoEstruturado == this.contrato.vcCodigoEstruturado &&
                this.processoCliente == this.contrato.processoCliente &&
                this.codSolicitante == this.contrato.codSolicitante &&
                this.codUnidade == this.contrato.codUnidade &&
                this.objetoContrato == this.contrato.vcObjetoContrato &&
                this.vigenciaInicio ==
                    this.$moment(this.contrato.dtInicioVigencia).format(
                        'DD/MM/YYYY'
                    ) &&
                this.vigenciaFim ==
                    this.$moment(this.contrato.dtFimVigencia).format(
                        'DD/MM/YYYY'
                    ) &&
                this.prazoInicio ==
                    this.$moment(this.contrato.dtInicioPrazoExecucao).format(
                        'DD/MM/YYYY'
                    ) &&
                this.prazoFim ==
                    this.$moment(this.contrato.dtFimPrazoExecucao).format(
                        'DD/MM/YYYY'
                    ) &&
                // this.dtEnvioFornecedor ==
                //     this.$moment(this.contrato.dtEnvioFornecedor).format(
                //         'DD/MM/YYYY'
                //     ) &&
                // this.dtRetornoFornecedor ==
                //     this.$moment(this.contrato.dtRetornoFornecedor).format(
                //         'DD/MM/YYYY'
                //     ) &&
                // this.dtEnvioDiretoria ==
                //     this.$moment(this.contrato.dtEnvioDiretoria).format(
                //         'DD/MM/YYYY'
                //     ) &&
                // this.dtRetornoDiretoria ==
                //     this.$moment(this.contrato.dtRetornoDiretoria).format(
                //         'DD/MM/YYYY'
                //     ) &&
                this.flGarantiaContratual ==
                    this.contrato.flGarantiaContratual &&
                this.percGarantia ==
                    (this.contrato.nuPercentGarantia
                        ? this.contrato.nuPercentGarantia
                        : 0) &&
                this.tipoContratoId == this.contrato.idTipoContrato &&
                this.tipoMovimento == this.contrato.tipoMovimento &&
                this.renovacao == this.contrato.renovacao &&
                this.indideReajuste == this.contrato.indiceReajuste &&
                this.valorReajuste == this.contrato.valorReajuste &&
                this.tipoSetor == this.contrato.tipoSetor &&
                this.tipoRelacao == this.contrato.tipoRelacao
            )
        },

        validaPercentualGarantia() {
            if (
                (this.flGarantiaContratual === 1 && this.percGarantia > 0) ||
                (this.flGarantiaContratual === 0 && this.percGarantia === 0)
            ) {
                return true
            }
            return false
        },

        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        apostilamento() {
            return this.situacoesVigenteDistribuido()
        },

        contratoElaboracao() {
            return (
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_EM_ELABORACAO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO
            )
        },

        aditivarContrato() {
            return (
                this.$temAcessoView('CONT-ADITIV-00') &&
                this.contrato.idSituacaoContrato == situacaoContrato.INICIADO_ADITIVO_CONTRATO
            )
        },

        atualizacaoContrato() {
            return (this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido())
        },

        verificaOperacao() {
            if (this.apostilamento() && this.apostilar) {
                this.operacao = 'APOSTILAR'
                this.labelJustificativa = 'do Apostilamento'
                this.textoInfoJustificativa = 'apostilamento'
            } else if (this.contratoElaboracao() || this.atualizacaoContrato()) {
                this.operacao = 'ATUALIZAR'
                
            }
        },

        verificaCampoApostilamento() {
            if (this.apostilamento() && this.apostilar) {
                if (this.justificativaApostilamento != '') {
                    return true
                }
            } else if (this.contratoElaboracao() || this.aditivarContrato()) {
                return true
            } else if(this.atualizacaoContrato() && !this.apostilar) {
                 if (this.justificativaApostilamento != '') {
                    return true
                }
            }
            return false
        },

        verificaCampoNumeroContrato() {
            if (this.apostilamento()) {
                return true
            } else if (
                (this.contratoElaboracao() || 
                this.aditivarContrato()) &&
                this.codigoEstruturado.length > 0) 
            {
                return true
            }
            return false
        }
    },

    created() {
        this.apostilar = this.$route.params.apostilar != undefined ? this.$route.params.apostilar : false
        this.obterContrato()
    },

    computed: {
        desabilitarBtnSalvar() {
            if (this.contratoElaboracao() || this.atualizacaoContrato()) {
                return this.$v.$invalid
            } else {
                if (this.$v.$invalid) return true
                else if (this.justificativa == '') return true

                return false
            }
        }
    },

    watch: {
        flGarantiaContratual() {
            if (this.flGarantiaContratual === 0) {
                this.percGarantia = 0
            }
        }
    },

    validations: {
        idContrato: {
            contratoAlterado() {
                return !this.registrosInalterados()
            }
        },
        objetoContrato: {
            required
        },
        codSolicitante: {
            required
        },
        codUnidade: {
            required
        },
        vigenciaInicio: {
            required
        },
        vigenciaFim: {
            required
        },
        prazoInicio: {
            required
        },
        prazoFim: {
            required
        },
        // dtEnvioFornecedor: {
        //     required
        // },
        // dtRetornoFornecedor: {
        //     required
        // },
        // dtEnvioDiretoria: {
        //     required
        // },
        // dtRetornoDiretoria: {
        //     required
        // },
        percGarantia: {
            required,
            validaPercentualGarantia() {
                return this.validaPercentualGarantia()
            }
        },
        justificativaApostilamento: {
            verificaCampoApostilamento() {
                return this.verificaCampoApostilamento()
            }
        },
        codigoEstruturado: {
            verificaSituacao() {
                return this.verificaCampoNumeroContrato()
            }
        }

    }
}
</script>
